export default "__VITE_ASSET__frnGBwCv__"